import { CORE_URL } from "utils/functions"

export async function fetchInvoicePdfBlob({
  invoiceId,
  organizationId,
  token,
}) {
  const url = `${CORE_URL}/invoices/pdf/?organizationId=${organizationId}&invoiceId=${invoiceId}`
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  })
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`)
  }
  const arrayBuffer = await response.arrayBuffer()
  return new Blob([arrayBuffer], { type: "application/pdf" })
}

export async function fetchInvopopPdfBlob({ siloId, token }) {
  const url = `${CORE_URL}/invopop/pdf/pdf_invoice/${encodeURIComponent(siloId)}`
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Access-Control-Allow-Origin": "*",
    },
  })
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`)
  }
  const arrayBuffer = await response.arrayBuffer()
  return new Blob([arrayBuffer], { type: "application/pdf" })
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(url)
}
